module.exports = __webpack_public_path__ + "static/img/banner_exp.4746f269.jpg";